"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePayrollDataRequestKey = exports.createUniquePayrollDataKey = exports.createDefaultPayrollResponse = exports.createHashFromHashMetadata = void 0;
const crypto_1 = require("crypto");
function createHashFromHashMetadata(metadata) {
    return (0, crypto_1.createHash)('sha256').update(JSON.stringify(metadata)).digest('hex');
}
exports.createHashFromHashMetadata = createHashFromHashMetadata;
function createDefaultPayrollResponse() {
    return {
        hash: createHashFromHashMetadata([]),
        hash_metadata: [],
        payroll_data: [],
    };
}
exports.createDefaultPayrollResponse = createDefaultPayrollResponse;
function createUniquePayrollDataKey({ payout_date, creditor_id, grouping, }) {
    return `${payout_date}-${creditor_id}-${grouping ?? ''}`;
}
exports.createUniquePayrollDataKey = createUniquePayrollDataKey;
function generatePayrollDataRequestKey({ payroll_id, creditor_id, grouping, }) {
    return `${payroll_id}-${creditor_id}-${grouping ?? ''}`;
}
exports.generatePayrollDataRequestKey = generatePayrollDataRequestKey;
